module.exports = __webpack_public_path__ + "img/house_pv_idle_online.82b38581.png";